export const SLIDE_HEIGHT = 450;
export const SLIDE_HEIGHT_TABLET = 496;
export const SLIDE_HEIGHT_LAPTOP = 548;
export const SLIDE_HEIGHT_LAPTOP_LARGE = 560;

export const MONTHLY_PRICE_BILLED_YEARLY = 7.92;
export const ANNUAL_FEE = 95;
export const MONTHLY_PRICE = 13;
